import React from 'react'

export default () => (
    <div>
		Home
	</div>
)